import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchCustomTypes } from 'src/services/napi/customTypes/fetchCustomTypes';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { useNotification } from '../../../../providers/notificationsProvider';

const fetchContentModel = async () => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;

  const data = await fetchCustomTypes(currentProject._id);
  return data?.customTypes;
};

export const useGetContentModelsQuery = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.CONTENT_MODELS], () => fetchContentModel(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
